/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
// Deliberately the leaf module rather than the `./helpers` barrel: this file is
// itself re-exported from `helpers/index.tsx`, so importing the barrel here
// closes the helpers -> routes -> adminPages cycle, which renders a blank page
// with no console error. See the note at the top of `appType.ts`.
import { hasFirebaseMessaging } from './appType';
import { firebaseConfig } from './firebaseConfig';

const app = hasFirebaseMessaging ? initializeApp(firebaseConfig) : null;
const messaging = hasFirebaseMessaging && getMessaging(app!);

export { messaging };
